const PADDING = 10;

export interface Position {
    top: number;
    left: number;
}

export const getMinHorizontalPosition = (windowWidth: number, rectWidth: number, paddings: number): number => {
    const realPosX = windowWidth - rectWidth - paddings;
    return realPosX < 0 ? paddings : realPosX;
};

export const calculatePosition = (element: HTMLElement, currentPos: Position): void => {
    const hintRect = element.getBoundingClientRect();
    const windowWidth = Math.min(window.innerWidth, window.document.body.clientWidth);
    let { left } = currentPos;
    const { top } = currentPos;

    if (hintRect.width + left + PADDING >= windowWidth) {
        left = getMinHorizontalPosition(windowWidth, hintRect.width, PADDING);
    } else {
        left += PADDING;
    }

    element.style.left = `${left}px`;
    element.style.top = `${top + PADDING}px`;
    element.style.opacity = '1';
};
